<template>
    <!-- 升学途径分析 -->
    <div class="test_mains">
    	<div class="header">
    		<h5>升学途径分析<span></span></h5>
    		<p class="remind"><span>*</span>为了给您出具合理的升学建议，请您根据您的实际情况认真作答！</p>
    	</div>
        <div class="question_box">
            <div class="content">
                <h6>请完成以下关于您的必选测试题目</h6>
                <Question></Question>
            </div>
        </div>
    </div>
</template>
<style type="text/css" lang='less' scoped>
.test_mains {
    height: 100%;
	.header {
		position: relative;
		z-index: 2;
		// height: 232px;
		// background: url(/imgs/wayToStudy/analysis_test/test_banner.png) no-repeat center center;
        background: #fff;
		h5 {
			line-height: 60px;
		    color: #338cef;
		    font-size: 16px;
		    font-weight: 600;
		    // padding-left: 50px;
		    // background: url(/imgs/wayToStudy/main/icon_title.png) no-repeat 20px center;
            border-bottom: 1px solid #D8D8D8;
            margin: 0 auto;
            width: 95%;
            span{
                position: relative;
                bottom: 0;
                left: 0;
                width: 36px;
                height: 2px;
                background: #157DFA;
                display: block;
            }
		}
		.remind {
			padding-left: 50px;
           padding: 10px 34px;
			span {
				color: red;
				line-height: 20px;
				font-size: 13px;
			}
		}
	}
    .question_box{
        position: relative;
		z-index: 1;
		min-height: 500px;
		background-color: #fff;
		// padding: 0px 45px;
        // width: 95%;
        margin: 0 auto;
        // border: 1px solid #D8D8D8;
    }
	.content {
        width: 95%;
        margin: 0 auto;
        border: 1px solid #D8D8D8;
        padding: 20px;
        box-sizing: border-box;
		
		// margin-top: -20px;
        h6 {
            line-height: 70px;
            font-size: 17px;
            // text-align: center;
            font-weight: 600;
        }
	}
}
</style>
<script>
import StepBar from './stepBar.vue';
import Question from './test_question_mobile.vue';
export default {
    components: { StepBar, Question },
    data() {
        return {}
    },
    computed: {},
    methods: {
        textPast() {
            var _this = this;
            var token = window.sessionStorage.getItem('ymtxToken')||window.localStorage.getItem('localtoken');
            this.$ajax
                .post(this.G_testuri + '/test/create', {
                },{
                    headers:{
                        token: token
                    }
                })              
                // 监听数据返回
                .then(function(res) {})
                .catch(function(error) {})
        },
    },
    watch: {},
    created() {},
    mounted() {
        this.textPast();

    }
}
</script>